var module = angular.module('octopusApp.projects');

module.directive('deploymentCreateEnvironmentSelector', function() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            edit: '=',
            availableEnvironments: '=',
            selectedEnvironments: '=',
            project: '=',
            newDeployments: '='
        },
        templateUrl: 'areas/projects/deployment-create/deployment-create-environment-selector.html',
        controllerAs: 'vm',
        bindToController: true,
        controller: function ($scope, busy, pollLoop, octopusRepository) {
            var vm = this;

            vm.latest = {};
            vm.getEnvironmentName = getEnvironmentName;

            function getEnvironmentName(environmentId) {
                return vm.availableEnvironments.filter(function(env) { return env.Id === environmentId; })[0].Name;
            }

            function getLatestEnvironmentReleases() {
                return octopusRepository.Dashboards.getProjectDashboard(vm.project).then(function(dash){
                    _.each(dash.Items, function (item) {
                        vm.latest[item.EnvironmentId] =  item;
                    });
                });
            }

            function init(){
                var loop = pollLoop.create($scope, function () { return getLatestEnvironmentReleases(); });
                loop.startImmediately();
            }

            init();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/deployment-create/deployment-create-environment-selector.js
// module id = 2346239287019313
// module chunks = 1